/* eslint-disable react-hooks/exhaustive-deps */

import equal from "fast-deep-equal";
import React, { useCallback, useEffect, useMemo } from "react";

export function useDeepCompareMemoize(dependencies: React.DependencyList) {
  const dependenciesRef = React.useRef<React.DependencyList>(dependencies);
  const signalRef = React.useRef<number>(0);

  if (!equal(dependencies, dependenciesRef.current)) {
    dependenciesRef.current = dependencies;
    signalRef.current += 1;
  }

  return useMemo(() => dependenciesRef.current, [signalRef.current]);
}

export function useDeepCompareMemo<T>(
  factory: () => T,
  dependencies: React.DependencyList,
) {
  return useMemo(factory, useDeepCompareMemoize(dependencies));
}

export function useDeepCompareCallback<T extends (...args: any[]) => any>(
  callback: T,
  dependencies: React.DependencyList,
) {
  return useCallback(callback, useDeepCompareMemoize(dependencies));
}

export function useDeepCompareEffect(
  effect: React.EffectCallback,
  dependencies: React.DependencyList,
) {
  useEffect(effect, useDeepCompareMemoize(dependencies));
}
